import { API_BASE_URL } from "../Common/Common";

// Mirrors HasDataPlaces.js exactly — see openwebninja_places_photo.php's
// own comment for the full story. Added 2026-09-24 so PlaceMenu.js's
// _autoSetPhotoSearch can try whichever provider PLACES_PROVIDER actually
// points to first, instead of always calling HasData regardless of that
// setting.
export default class OpenWebNinjaPlaces {
  // query: a specific search string, e.g. "Eiffel Tower, Paris" — a plain
  // place name plus city/country gives the search the best chance of
  // returning that exact place as its first result. lat/lng (optional) geo-
  // bias the search — important for common place names ("Pizza", "Coffee
  // Shop") where an unscoped search could match the wrong city entirely.
  static searchPlacePhoto = (query, callback, lat, lng) => {
    if (!query) {
      callback(null);
      return;
    }
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);
    fetch(`${API_BASE_URL}/openwebninja_places_photo.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ query, lat, lng }),
      signal: controller.signal,
    })
      .then((r) => r.json())
      .then((data) => {
        clearTimeout(timeoutId);
        callback(data && data.photo ? data.photo : null);
      })
      .catch((err) => {
        clearTimeout(timeoutId);
        console.log("OpenWebNinjaPlaces.searchPlacePhoto error:", err);
        callback(null);
      });
  };
}
